import React from 'react';
import { useSignState } from 'context/signview';
import { useMutation } from 'react-query';
import { fetcher } from 'api/client';
import { clientContractAction } from 'api/actions/contracts';
import { useTranslation } from 'react-i18next';
import { toast } from 'components/Shared/Toast';
import { Button, Spinner } from 'reactstrap';


function ConfidentialAttachmentItem({ attachment = {} }) {
    const { t } = useTranslation();
    const { contractId, jwt } = useSignState();
    const { name, downloadable, _id } = attachment;

    const { mutate: openConfidentialMutation, isLoading } = useMutation(() =>
        fetcher(clientContractAction(contractId, 'downloadconfidentialattachment', { extraAttachmentId: _id }), jwt), {
        onSuccess: (data) => {
            window.open(data.url);
        },
        onError: (error) => {
            toast.error(t(`errors.${error.message}`));
        }
    })

    const handleOpenConfidential = () => {
        openConfidentialMutation()
    }

    return (
        <div className="d-flex border rounded mb-2">
            <div className="d-flex p-3 border-right">
                <div className="lead align-self-center mb-0">
                    <i className="fas fa-user-secret"></i>
                </div>
            </div>
            <div className="bg-grey p-3 w-100">
                <p className="d-block font-weight-bold mb-0 text-break">
                    <i className="fas fa-check-circle text-success float-left pr-1 pt-1"></i>{' '}{name}</p>
                <small className="d-block text-muted mb-2"></small>
                <Button
                    block
                    color="secondary"
                    disabled={!attachment.url || isLoading}
                    onClick={handleOpenConfidential}>
                    {isLoading && <Spinner size="sm" />}{' '}
                    {t('contracts.documents.download')}
                </Button>
            </div>
        </div>
    )
}

export default function ConfidentialAttachmentsTab() {
    const { contract } = useSignState();
    const confidentialAttachments = contract.confidentialAttachments || []
    return (
        <div>
            {confidentialAttachments.map((attachment) => (
                <ConfidentialAttachmentItem
                    attachment={attachment}
                    key={attachment._id}
                />
            ))}
        </div>
    )
}